import { AbstractControl } from '@angular/forms';

export function WorksiteRequired(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const hasCoordinator = parsedValue.some((p) => p.isCoordinator);
    if (hasCoordinator) {
      return;
    }
  }

  return { WorksiteRequired: true };
}
